import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import PolicyIcon from '@mui/icons-material/Policy';

import {

    ContentHeaderMenu,
    ContentHeaderMenuIcon,
    ContentHeaderMenuDecoration,
    ContentHeaderMenuDecorationText,
    ContentHeaderMenuContainer,

    HeaderMenuContainer,
    HeaderMenuItem,
    HeaderMenuItemIcon,
    HeaderMenuItemText

} from "./styled";

import { DoLogout } from "services/authentication";
import { parseInitialize } from "utils/parsers";
import { CoreContext } from "context/CoreContext";
import { parseStrapiImage } from "utils";

export default function DashboardHeaderMenu({ }) {

    const history = useHistory();
    const navigate = to => history.push(`/${to}`);

    const { user, setModal } = useContext(CoreContext)

    const [opened, setOpened] = useState(false)

    const exit = async () => {
        setOpened(false)
        await DoLogout()
        navigate('login')
    }

    const handleOpenCookies = () => {
        setModal({
            type: "cookies",
            item: {
            },
        })
    }

    return (
        <>
            <ContentHeaderMenuContainer>
                <ContentHeaderMenu onClick={() => setOpened(!opened)}>
                    <ContentHeaderMenuIcon opened={opened} />
                    <ContentHeaderMenuDecoration image={user?.image?.url ? parseStrapiImage(user?.image?.url) : null}>
                        <ContentHeaderMenuDecorationText>{user?.image ? null : parseInitialize(user?.name)}</ContentHeaderMenuDecorationText>
                    </ContentHeaderMenuDecoration>
                </ContentHeaderMenu>
                {
                    !opened ? null :
                        <HeaderMenuContainer>
                            <HeaderMenuItem onClick={handleOpenCookies}>
                                <PolicyIcon />
                                <HeaderMenuItemText>Política de Privacidade</HeaderMenuItemText>
                            </HeaderMenuItem>
                            <HeaderMenuItem onClick={exit}>
                                <HeaderMenuItemIcon />
                                <HeaderMenuItemText>Sair</HeaderMenuItemText>
                            </HeaderMenuItem>
                        </HeaderMenuContainer>
                }
            </ContentHeaderMenuContainer>
        </>
    );
}